/* eslint-disable react/prop-types */
import React from 'react';

import { regularExpressions as regex } from '@utils';

import TextField from '../TextField';

const RFC_LENGTH = 13;

const RFCField = props => {
  const {
    onChange,
    inputProps,
    ...restProps
  } = props;

  const handleChange = event => {
    const inputEvent = event;
    const { value } = event.target;

    inputEvent.target.value = value.replace(regex.onlyLettersAndNumbers, '').toUpperCase();

    onChange(inputEvent);
  };

  return (
    <TextField
      {...restProps}
      onChange={handleChange}
      inputProps={{
        minLength: RFC_LENGTH,
        maxLength: RFC_LENGTH,
        ...inputProps
      }}
    />
  );
};

export default RFCField;
